// extracted by mini-css-extract-plugin
module.exports = {"taskInput":"TaskInput_taskInput__39W9T","input":"TaskInput_input__2N6To","submitButton":"TaskInput_submitButton__2t75b"};